import { Field } from "@comet/admin";
import { type VividFieldProps } from "@src/components/fields/interfaces";
import { type FC, type PropsWithChildren } from "react";

export const AsyncSelect: FC<PropsWithChildren<VividFieldProps>> = ({ required = false, variant, label, ...rest }) => {
    const effectiveVariant = variant ?? (label ? "horizontal" : "vertical");
    return (
        <Field
            fullWidth
            required={required}
            fieldContainerProps={{ variant: effectiveVariant }}
            label={label}
            components={{ IndicatorSeparator: () => null }}
            {...rest}
        />
    );
};
